import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
import NewTable from '../NewTable';

const BotTable = (props) => {
  const {
    title,
    error,
    loading,
    contentItems,
    selectEnabled,
    onItemInstallClick,
    onItemHideClick,
    onItemHideOffClick,
    onItemUninstallClick,
    name,
    headerItems,
    lengthOptions,
    total,
    order,
    orderBy,
    rowsPerPage,
    page,
    selected,
    handleAllClick,
    handleCheckClick,
    handleChangePage,
    handleChangeRowsPerPage,
    handleSortClick,
  } = props;

  return (
    <Card sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '16px 16px 0',
          flex: '1 0 60px',
        }}
      >
        <Typography variant="h5">{title}</Typography>
        {!loading && contentItems.length > 0 && (
          <CardActions
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'end',
              rowGap: 1,
            }}
          >
            <Stack direction="row" gap={1}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemInstallClick}
              >
                선택 설치
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemHideClick}
              >
                선택 숨김
              </Button>
            </Stack>
            <Stack direction="row" gap={1}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemHideOffClick}
              >
                선택 숨김 해제
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemUninstallClick}
              >
                선택 제거
              </Button>
            </Stack>
          </CardActions>
        )}
      </Box>
      <CardContent>
        {!loading &&
          contentItems.length === 0 &&
          error &&
          '설치된 봇이 없습니다.'}
        {contentItems.length > 0 && (
          <NewTable
            {...{
              selectable: true,
              name,
              headerItems,
              contentItems,
              lengthOptions,
              total,
              order,
              orderBy,
              rowsPerPage,
              page,
              selected,
              handleAllClick,
              handleCheckClick,
              handleChangePage,
              handleChangeRowsPerPage,
              handleSortClick,
            }}
          />
        )}
      </CardContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          mx: 2,
          mt: -2,
          mb: 2,
        }}
      >
        {!loading && contentItems.length > 0 && (
          <CardActions
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'inherit',
              rowGap: 1,
            }}
          >
            <Stack direction="row" gap={1}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemInstallClick}
              >
                선택 설치
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemHideClick}
              >
                선택 숨김
              </Button>
            </Stack>
            <Stack direction="row" gap={1}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemHideOffClick}
              >
                선택 숨김 해제
              </Button>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                disabled={!selectEnabled}
                onClick={onItemUninstallClick}
              >
                선택 제거
              </Button>
            </Stack>
          </CardActions>
        )}
      </Box>
    </Card>
  );
};

export default BotTable;
